import React from 'react';

import MobileContext from 'Shared/contexts/MobileContext';
import { useWindowSize } from 'Shared/utils/hooks';
import { screenBreakPoints } from 'Shared/constants/constants';

type Props = {
  children: React.ReactNode;
};

function MobileProvider({ children }: Props) {
  const windowSize = useWindowSize();
  const isMobile = windowSize.width <= screenBreakPoints.screenSm;

  return <MobileContext.Provider value={isMobile}>{children}</MobileContext.Provider>;
}

export default MobileProvider;
